import store from "../../../../store/index";
import { has } from "../../../../utils/menu-context";

export const createConditionAction = () => {
    let myRoleName = []
    store.state.resource.auth.info?.roles.forEach(userRole => {
        myRoleName.push(userRole.refRole.name)
    })

    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (has({ menuContext, key: "forRequest" }) || record.createBy === store.state.resource.auth.info.user?.username) {
                if (["approve"].includes(record.refStatus?.key) && ["waitPayment"].includes(record.refPaymentStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forApprove" })) {
                if (["waitPayment", "waitApprovePayment"].includes(record.refPaymentStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canArchive: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canArchive" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canDelete: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canDelete" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canWaitApprovePayment: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (["waitPayment"].includes(record.refPaymentStatus?.key)) {
                if (record.createBy === store.state.resource.auth.info.user?.username) {
                    result = true || result;
                }
                else if (record.isOfficerCreate && has({ menuContext, key: "forRequest" })) {
                    result = true || result;
                }
            }
            return result
        },
        canApprove: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (has({ menuContext, key: "forApprove" })) {
                if (["waitApprovePayment"].includes(record.refPaymentStatus?.key)) {
                    result = true || result;
                }
            }
            return result
        },
        canReportReceipt: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forRequest" })) {
                if (["approve"].includes(record.refStatus?.key)
                    && ["approvePayment"].includes(record.refPaymentStatus?.key)
                ) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forApprove" })) {
                result = true || result;
            }
            return result
        }
    };
};

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return ["attachmentFeeSlips", "payFeeAtDate"].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["draft", "waitApprovePayment", "approvePayment", "cancel"],
            }),
            visibleField: ({ data }) => {
                return data.isFee;
            },
        },
        {
            check: ({ field }) => {
                return ["payDutyAtDate", "attachmentDutySlips"].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["draft", "waitApprovePayment", "approvePayment", "cancel"],
            }),
            visibleField: ({ data }) => {
                return data.isDuty;
            },
        },
        {
            check: ({ field }) => {
                return ["isApprovePayment", "isRejectPayment", "paymentRemark"].includes(field?.key);
            },
            visibleField: ({ initialModel }) => {
                return ["waitApprovePayment", "approvePayment", "cancel"].includes(initialModel.refPaymentStatus?.key);
            },
            inputPropField: ({ modelRef, initialModel, props }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["draft", "approvePayment", "cancel"],
                })({ modelRef, initialModel });
                common.disabled = common.disabled || viewOnly
                return common;
            }
        },
    ];
};

export const commonInputPropField = ({ disabledStatuses }) => ({ initialModel }) => {
    let enabled = undefined;
    if (disabledStatuses.includes(initialModel.refStatus?.key)) {
        enabled = false;
    }
    return { disabled: enabled !== undefined ? !enabled : undefined };
};

export const commonComponentProp = ({ disabledStatuses, disabledRequestTypes }) => ({ modelRef, initialModel }) => {
    let canCreate = undefined;
    let canDelete = undefined;
    if (disabledStatuses.includes(initialModel.refStatus?.key) || disabledRequestTypes.includes(modelRef.refRequestType?.key)) {
        canCreate = false;
        canDelete = false;
    }
    return { canCreate, canDelete };
};
